module.exports = __webpack_public_path__ + "1fcda2515f1a05b628e0d7e1fe244102.pdf";